var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_159)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 12.5C25 19.4036 19.4036 25 12.5 25C5.59644 25 0 19.4036 0 12.5C0 5.59644 5.59644 0 12.5 0C19.4036 0 25 5.59644 25 12.5ZM12.9479 9.22791C11.7321 9.73361 9.30223 10.7803 5.65823 12.3679C5.0665 12.6032 4.75652 12.8334 4.7283 13.0585C4.68061 13.4389 5.157 13.5887 5.8057 13.7927C5.89394 13.8204 5.98537 13.8492 6.07911 13.8797C6.71734 14.0871 7.57587 14.3298 8.02218 14.3395C8.42703 14.3482 8.87889 14.1813 9.37776 13.8388C12.7825 11.5405 14.54 10.3788 14.6503 10.3538C14.7282 10.3361 14.836 10.3139 14.9091 10.3789C14.9822 10.4438 14.975 10.5669 14.9673 10.5999C14.9201 10.8011 13.0501 12.5395 12.0824 13.4392C11.7807 13.7197 11.5667 13.9186 11.523 13.9641C11.425 14.0659 11.3251 14.1621 11.2291 14.2547C10.6362 14.8262 10.1916 15.2549 11.2538 15.9549C11.7642 16.2912 12.1727 16.5694 12.5802 16.8469C13.0252 17.15 13.4691 17.4522 14.0434 17.8287C14.1897 17.9246 14.3294 18.0242 14.4655 18.1212C14.9834 18.4905 15.4487 18.8222 16.0235 18.7693C16.3576 18.7385 16.7026 18.4245 16.8778 17.4877C17.2919 15.274 18.1059 10.4774 18.294 8.50088C18.3105 8.32771 18.2897 8.10608 18.2731 8.00879C18.2564 7.91151 18.2216 7.77289 18.0952 7.67028C17.9454 7.54875 17.7142 7.52313 17.6108 7.52495C17.1407 7.53323 16.4193 7.78405 12.9479 9.22791Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "current"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.7b281004e2ddd6379ef0862fa1ba3912.svg";
export { ForwardRef as ReactComponent };